import React, {useEffect, useState} from 'react';
import {Field} from 'formik';
import {Validation} from '../../../../../utils';
import DataItemRadio from '../../../_common/components/DataItemRadio';

const RadioColumn = ({cellContent}) => {
  const [valid, setValid] = useState(false);
  const type1 = `1-${cellContent._id}`;
  const type8 = `8-${cellContent._id}`;

  useEffect(() => {
    const isValid = Validation.canSendInvoiceOrderToRivhit(new Date(cellContent.createdAt));
    setValid(isValid);
  }, [cellContent.createdAt]);

  return (
    <div className="d-flex align-items-center">
      <Field name={type1}>
        {({field, form}) => (
          <DataItemRadio
            type="checkbox"
            fieldName={type1}
            id={type1}
            checked={field.value === true}
            onChange={() => {
              const isCurrentlyChecked = field.value === true;
              form.setFieldValue(type1, !isCurrentlyChecked);
              form.setFieldValue(type8, false);
            }}
            disabled={!cellContent.canCreate || !valid || !cellContent.status === 1 || !cellContent.status === 4}
          />
        )}
      </Field>
      <div className="mx-2"/>
      <Field name={type8}>
        {({field, form}) => (
          <DataItemRadio
            type="checkbox"
            fieldName={type8}
            id={type8}
            checked={field.value === true}
            onChange={() => {
              const isCurrentlyChecked = field.value === true;
              form.setFieldValue(type8, !isCurrentlyChecked);
              form.setFieldValue(type1, false);
            }}
            disabled={!cellContent.canCreate || !valid || !cellContent.status === 1 || !cellContent.status === 4 || !cellContent.allowInvoiceDeal}
          />
        )}
      </Field>
    </div>
  );
};

export function RadioColumnFormatter(cellContent) {
  return <RadioColumn cellContent={cellContent}/>;
}